import PdcCard from './PdcCard'

export type { PdcCardItem } from './PdcCard'

export default PdcCard
